export default __webpack_public_path__ + "static/media/sectionSocialMedia.8eef5ad1.png";